export enum LayoutStyle {
    MAX = "max",
    MIN = "min"
}
